import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { LocationComponent } from '@rocksoft/places';

@Injectable()
export class DevicesDeactivateGuard {
  private readonly router = inject(Router);

  canDeactivate: CanDeactivateFn<LocationComponent> = (
    _component: LocationComponent,
    currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ) => {
    if (nextState?.url === '/places') {
      // Use currentRoute.params directly - the store's router state may already be updated
      const brandId = currentRoute.params.brandId;
      const locationId = currentRoute.params.locationId;

      if (brandId && locationId) {
        void this.router.navigate(['/places', 'brands', brandId, 'locations', locationId]);
      } else {
        void this.router.navigate(['/places']);
      }
    }
    return true;
  };
}
